export default "__VITE_ASSET__tolO9LDs__"